"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigationContent = void 0;
const languageUtils_1 = require("../languageUtils");
// NOTE: Record<keys, values>
const navigationLang = {
    en: {
        world: 'world',
        gameplay: 'gameplay',
        characters: 'characters',
        videos: 'videos',
        products: 'products',
    },
    ca: {
        world: 'world',
        gameplay: 'gameplay',
        characters: 'characters',
        videos: 'videos',
        products: 'products',
    },
    uk: {
        world: 'world',
        gameplay: 'gameplay',
        characters: 'characters',
        videos: 'videos',
        products: 'products',
    },
    fr: {
        world: 'MONDE',
        gameplay: 'gameplay',
        characters: 'PERSONNAGES',
        videos: 'Vidéos',
        products: 'Produits',
    },
    de: {
        world: 'WELT',
        gameplay: 'gameplay',
        characters: 'CHARAKTERE',
        videos: 'Videos',
        products: 'Produkte',
    },
    es: {
        world: 'MUNDO',
        gameplay: 'JUEGO',
        characters: 'PERSONAJES',
        videos: 'Vídeos',
        products: 'Productos',
    },
    au: {
        world: 'world',
        gameplay: 'gameplay',
        characters: 'characters',
        videos: 'videos',
        products: 'products',
    },
    nz: {
        world: 'world',
        gameplay: 'gameplay',
        characters: 'characters',
        videos: 'videos',
        products: 'products',
    },
    it: {
        world: 'MONDO',
        gameplay: 'GIOCO',
        characters: 'PERSONAGGI',
        videos: 'videos',
        products: 'Prodotti',
    },
    pt: {
        world: 'MUNDO',
        gameplay: 'JOGABILIDADE',
        characters: 'PERSONAGENS',
        videos: 'videos',
        products: 'Produtos',
    },
    nl: {
        world: 'WERELD',
        gameplay: 'gameplay',
        characters: 'PERSONAGES',
        videos: 'videos',
        products: 'Producten',
    },
};
class navigationContent {
    constructor() {
        this.gameplay = document.querySelector('.navigation__gameplay');
        this.videos = document.querySelector('.navigation__videos');
        this.products = document.querySelector('.navigation__products');
        this.world = document.querySelector('.navigation__world');
        this.characters = document.querySelector('.navigation__characters');
        this.init();
    }
    init() {
        this.updateText();
    }
    updateText() {
        const language = (0, languageUtils_1.getLanguage)();
        const content = navigationLang[language] || navigationLang['en'];
        if (this.gameplay)
            this.gameplay.textContent = content.gameplay.toUpperCase();
        if (this.videos)
            this.videos.textContent = content.videos.toUpperCase();
        if (this.products)
            this.products.textContent = content.products.toUpperCase();
        if (this.world)
            this.world.textContent = content.world.toUpperCase();
        if (this.characters)
            this.characters.textContent = content.characters.toUpperCase();
    }
}
exports.navigationContent = navigationContent;
